import { Environment, Guard } from "./types";

export function createEnvironment(data: Record<string, unknown>): Environment {
  const get = (key: string) => data[key];

  const getAs = <T>(key: string, guard: Guard<T>): T | null => {
    const value = data[key];
    return guard(value) ? value : null;
  };

  return { get, getAs };
}
